@import "@/scss/use-bootstrap-mixins.scss";

.desktopOptionspadding {
  padding: 0;
}

.card {
  border-radius: 14px;

  @include media-breakpoint-up(lg) {
    width: 420px;
    max-width: 420px;
  }

  .card_body {
    padding: 30px 23px;
  }
}

.card_container {
  @include media-breakpoint-up(lg) {
    width: 420px;
    max-width: 420px;
  }
}

.deal {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;

  .deal_banner {
    background-color: #f0f0f0;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    text-align: center;
    padding: 8px;

    span {
      display: block;
      text-align: center !important;
      font-family: "Roboto" !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      color: #000 !important;
    }
  }
}

.primary {
  background-color: var(--rs-theme);
  color: $textColorOnPrimary !important;

  .customise_booking {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: $textColorOnPrimary !important;
  }

  .header {
    display: flex;
    justify-content: space-between;

    .first {
      text-align: left;
      flex: 1;

      > span:nth-child(1) {
        font-size: 18px !important;
        font-weight: 500 !important;
        margin: 0;
        color: $textColorOnPrimary !important;
      }
    }

    .last {
      text-align: right;

      > span:nth-child(1) {
        font-size: 18px !important;
        font-weight: 500 !important;
        margin: 0 !important;
        color: $textColorOnPrimary !important;
        text-align: right !important;
        display: block !important;
      }

      .pricing_desc {
        display: flex;
        justify-content: end;
        gap: 4px;

        span {
          font-size: 11px !important;
          font-weight: 500 !important;
        }

        .savings_badge {
          background-color: $shade2;
          padding: 1px 4px;
          border-radius: 40%;
          opacity: 1 !important;
          margin-left: 4px;
        }
      }

      .customText {
        flex-direction: column;
      }
    }
  }

  .descriptionsInclusions {
    font-size: 13px;
    font-weight: 600;
  }

  .description {
    display: flex;
    margin-top: 8px;
    margin-bottom: 32px;
    flex-wrap: wrap;
    width: 100%;

    .inclusion {
      width: 50%;
      display: flex;
      padding-right: 5px;

      .tick {
        svg {
          width: 13px;
          height: 9px;
          margin-right: 13px;
        }
      }

      .text {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}

.upsell {
  background-color: #f0f0f0;
  color: #222 !important;
  max-width: 420px;
  // padding: 30px 23px;

  .header {
    display: none;
  }

  .customise_booking {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #222 !important;
  }

  button {
    label {
      cursor: pointer;
    }
  }

  .upsell_header {
    display: flex;
    color: #222 !important;

    @include media-breakpoint-up(lg) {
      justify-content: space-between;
    }

    span {
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      color: #000 !important;
    }

    label {
      font-size: 10px;
      font-weight: 600;
      color: #000 !important;
    }

    img {
      width: 55px;
      height: 55px;
    }

    .left {
      display: flex;
      flex: 1;
      flex-direction: column;

      span {
        font-weight: 600 !important;
        font-size: 18px !important;
      }

      label {
        font-weight: 600 !important;
        font-size: 12px !important;
      }
    }

    .right {
      display: flex;
      text-align: right;
      flex-direction: column;

      span {
        font-weight: 600 !important;
        font-size: 18px !important;
      }

      label {
        font-weight: 500 !important;
        font-size: 12px !important;
      }
    }
  }

  .upsell_body {
    width: 100%;
    display: block;
    padding-bottom: 12px;
    img {
      max-width: 200px;
      display: block;
      margin: 0 auto;
    }
  }

  .description {
    display: none;
  }

  @include media-breakpoint-down(lg) {
    max-width: 100%;
  }
}

.customise {
  .alternateOptions {
    margin: 0 !important;
    font-size: 24px !important;
    font-weight: 700 !important;
  }

  .alternateDescription {
    margin: 13px 0 21px 0;
    padding: 0;
    font-size: 14px;
    font-weight: 400;
  }
}

.desktopOptions {
  background-color: #fff;
  color: #222;
  padding: 0 !important;

  .customise {
    .alternateOptions {
      margin: 0 !important;
      font-size: 16px !important;
      font-weight: 700 !important;
    }

    .alternateDescription {
      margin: 13px 0 21px 0;
      padding: 0;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .header {
    display: none;
  }

  .description {
    display: none;
  }
}

.biggerUnit {
  margin-top: 24px;
  padding: 10px 20px 20px 20px;

  @include media-breakpoint-up(lg) {
    margin-top: 0px;
  }

  span {
    display: block;
    margin-bottom: 18px;
    font-size: 28px !important;
    font-weight: 500 !important;
    text-align: center !important;
  }
}

.desktop {
  display: none !important;
  @include media-breakpoint-up(lg) {
    display: block !important;
  }
}

.mobile {
  display: block !important;
  height: 100% !important;
  overflow-y: scroll;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    width: 0 !important;
    background: transparent !important;
  }

  @include media-breakpoint-up(sm) {
    overflow-y: hidden;
  }

  @include media-breakpoint-up(lg) {
    display: none !important;
  }
}

.underline {
  border-bottom: 2px solid $textColorOnPrimary;
}
